import './LuckyWheel.less';
import React from 'react';
import luckyWheelSmallIcon from './images/lucky-wheel-small-icon.png';
import clsx from 'clsx';

const LuckyWheelBanner = ({ luckyWheelName, luckyWheelDescription, oneLine = false, ...props }) => {
    return (
        <div {...props} className={clsx('lucky-wheel-banner', { mobile: oneLine })}>
            <div className="flex justify-center flex-col">
                <img src={luckyWheelSmallIcon} alt="lucky-wheel-small-icon" width="56px" height="58px" />
            </div>
            <div className="ml-10 flex justify-center flex-col">
                <h2 className="fs-18">{luckyWheelName}</h2>
                <span className="fs-13">{luckyWheelDescription}</span>
            </div>
        </div>
    );
};

export default LuckyWheelBanner;
